import {styled} from "@mui/material";

export const Wrapper = styled('div')(
  {
    padding: '2px',
      color: "white"
  },
);
